const tabSession = {
  setItem: (key, value) => {
    if (typeof Storage !== 'undefined') {
      sessionStorage.setItem(key, value)
    }
  },

  getItem: (key) => {
    if (typeof Storage !== 'undefined') {
      return sessionStorage.getItem(key)
    }
    return null
  },

  hasItem: (key) => {
    if (typeof Storage !== 'undefined') {
      return (sessionStorage.getItem(key) !== null)
    }
    return false
  },

  removeItem: (key) => {
    if (typeof Storage !== 'undefined') {
      return sessionStorage.removeItem(key)
    }
    return null
  }
}

export default tabSession
